import { render, staticRenderFns } from "./ViewUiEditorHome.vue?vue&type=template&id=fbd8f8be"
import script from "./ViewUiEditorHome.vue?vue&type=script&lang=js"
export * from "./ViewUiEditorHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports